import { Navigate, Route, Routes } from "react-router-dom";
import { DemoDataProvider } from "./hooks/useDemoData";

import Navbar from "./layout/Navbar";
import AccountSelector from "./layout/AccountSelector";
import { Toaster } from "sonner";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { PrivateRoutes } from "./PrivateRoutes";
import { PublicRoutes } from "./PublicRoutes";
import { AuthProvider } from "./auth/AuthProvider";
import AuthBoundary from "./auth/AuthBoundary";

export default function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        refetchOnMount: true,
      },
    },
  });
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Navbar />
        <div className="h-full  w-full">
          {/* Navigation Header */}
          <header className="bg-slate-100 border-b border-gray-200 px-6 py-3 w-full ">
            <AccountSelector />
          </header>

          {/* Main Content */}
          <main className="container mx-auto p-6 max-w-7xl pl-14 min-w-[1050px]">
            <AuthBoundary>
              <PrivateRoutes />
            </AuthBoundary>

            <PublicRoutes />

            <Toaster
              position="bottom-right"
              richColors
              expand={true}
              duration={4000}
              closeButton
              visibleToasts={1}
            />
          </main>
        </div>
      </AuthProvider>
    </QueryClientProvider>
  );
}
